import { Typography } from '@deere/fuel-react';
import { Modal, Alert, Button, Form } from '@deere/ux.uxframe-react'
import React from 'react';
import { useTranslation } from "react-i18next";

export default function AgreementPopUp({handleClose,showAgreement, submitResponse, messageKey}) {
    const { t } = useTranslation();
    
    const handleSubmit = event => {
        event.preventDefault();
        event.stopPropagation();
        
        submitResponse();
        handleClose();        
    }

    return (<Modal show={showAgreement} onHide={handleClose} size="lg">
                <Form validated={true} onSubmit={handleSubmit}>
                <Modal.Header closeButton>
                    <Modal.Title>{t('cm_lbl_agreemet_modal')}</Modal.Title>
                </Modal.Header>
                <Modal.Body scrollable={false} style={{maxHeight: '325px',overflowY: "auto"}}>
                    <Alert variant="warning">
                        <Typography variant="h5" style={{ textAlign: "justify" }} dangerouslySetInnerHTML={{ __html: t(messageKey) }}></Typography>
                    </Alert>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>{t('btn_cancel')}</Button>
                    <Button variant="primary" onClick={handleSubmit} type='submit'>{t('btn_review_submit')}</Button>
                </Modal.Footer>
                </Form>
            </Modal>)
}